export interface Country {
  code: string;
  name: string;
}

export const COUNTRIES: Country[] = [
  { code: 'BR', name: 'Brasil' },
  { code: 'PT', name: 'Portugal' },
  { code: 'AO', name: 'Angola' },
  { code: 'CV', name: 'Cabo Verde' },
  { code: 'GW', name: 'Guiné-Bissau' },
  { code: 'MO', name: 'Moçambique' },
  { code: 'ST', name: 'São Tomé e Príncipe' },
  { code: 'TL', name: 'Timor-Leste' },
  { code: 'AR', name: 'Argentina' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'CL', name: 'Chile' },
  { code: 'CO', name: 'Colombia' },
  { code: 'MX', name: 'México' },
  { code: 'US', name: 'Estados Unidos' },
  { code: 'GB', name: 'Reino Unido' },
  { code: 'ES', name: 'Espanha' },
  { code: 'FR', name: 'França' },
  { code: 'IT', name: 'Itália' },
  { code: 'DE', name: 'Alemanha' },
  { code: 'JP', name: 'Japão' },
  { code: 'AU', name: 'Austrália' },
  { code: 'CA', name: 'Canadá' },
  { code: 'CN', name: 'China' },
  { code: 'RU', name: 'Rússia' },
  { code: 'IN', name: 'Índia' },
  { code: 'ZA', name: 'África do Sul' },
].sort((a, b) => a.code === 'BR' ? -1 : b.code === 'BR' ? 1 : a.name.localeCompare(b.name));
